import { IAppState } from 'src/store/types';

export const getAppClientMenuData = (state: IAppState) => state.requests.appMenu.data;
export const getAppClientMenuDataLoading = (state: IAppState) => state.requests.appMenu.isLoading;
export const getAppClientMenuDataErrors = (state: IAppState) => state.requests.appMenu.error;
